import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const recapPdfUrl = (r) => `${process.env.REACT_APP_BACKEND_URL}${r.pdf_url}`;

export function recapDateFr(d) {
  try {
    return format(new Date(d), "EEEE d MMMM yyyy", { locale: fr });
  } catch {
    return d || "";
  }
}
